import { INTERCOM_BASE_SETTINGS } from 'components/IntercomLoaderWrapper/constants';

/**
 * Initial Intercom settings
 */
export const setIntercomBaseSettings = () => {
  // Do not run this code on the server
  if (typeof window === 'undefined') return;

  window.intercomSettings = INTERCOM_BASE_SETTINGS;
};
